export const SEARCHABLE_COLUMNS = ["id", "model", "type", "created_at", "user"];
